import { ErrorBoundary as ErrorBoundaryWrapper, type FallbackProps } from 'react-error-boundary';
import ErrorPageWhenNoConfig from '../../pages/ErrorPageWhenNoConfig';
import ErrorPage from '../../pages/ErrorPage';
import useAppConfig from 'canvas_states/config/useAppConfig';
import ThemeProvider from '../ThemeProvider/ThemeProvider';
import useTranslation from 'canvas_states/translation/useTranslation';

const ErrorFallback: React.FC<FallbackProps> = () => {
  const { config } = useAppConfig().states;

  const { t } = useTranslation().actions;

  return config?.partnerName ? (
    <ErrorPage
      errorMessage={t('offer.error.title')}
      reasonMessage={t('offer.error.text')}
      onActionClick={() => window.location.reload()}
      actionMessage={t('offer.error.button.reload')}
    />
  ) : (
    <ThemeProvider>
      <ErrorPageWhenNoConfig />
    </ThemeProvider>
  );
};

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => (
  <ErrorBoundaryWrapper FallbackComponent={ErrorFallback}>{children}</ErrorBoundaryWrapper>
);

export default ErrorBoundary;
